import React from 'react'
import { CloseCircle, TickCircle } from 'iconsax-react'
import { useTheme } from '@mui/material'

import Modal from '../../Modal'

import useStyles from './styles'

type AreYouSureModalProps = {
  open: boolean
  onClose: () => void
  onAccept: () => void
  title?: React.ReactNode
  reason?: React.ReactNode
  subtext?: React.ReactNode
  hideCancel?: boolean
}

const AreYouSureModal: React.FC<AreYouSureModalProps> = ({
  open,
  onClose,
  onAccept,
  title,
  reason,
  subtext = 'Continuing will discard those changes',
  hideCancel,
  ...props
}) => {
  const classes = useStyles()
  const theme = useTheme()
  return (
    // @ts-ignore
    <Modal
      open={open}
      onClose={onClose}
      PaperProps={{ style: { top: '53%', minWidth: '25%' } }}
      {...props}
    >
      <div className={classes.root}>
        <div className={classes.title}>{title || 'DISCARD CHANGES?'}</div>

        <div>
          <div className={classes.question}>
            <div>{reason || 'Are you sure you want to leave this page?'}</div>
            <div>{subtext}</div>
          </div>

          <div className={classes.options}>
            {!hideCancel && (
              <div className={classes.buttonText}>
                <span onClick={onClose} className='button'>
                  <CloseCircle
                    size={theme.size.base}
                    className={classes.iconNo}
                  />{' '}
                  No
                </span>{' '}
                Go back
              </div>
            )}

            <div className={classes.buttonText}>
              <span onClick={onAccept} className='button'>
                <TickCircle
                  size={theme.size.base}
                  className={classes.iconYes}
                />{' '}
                {hideCancel ? 'Ok' : 'Yes'}
              </span>{' '}
              Continue
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default AreYouSureModal
